import PropTypes from 'prop-types';
import React from 'react';

import { Trans, useTranslation } from '../../hooks/useTranslation';
import styles from './styles.module.styl';

const ConfiguredResources = ({ showClient, showApi, selectedClientName, selectedApiName }) => {
  const { t } = useTranslation('core');

  return (
    <React.Fragment>
      {showClient && showApi ? (
        <Trans
          i18nKey="quickstarts.downloadSampleModal.configuredResources.clientAndApi"
          components={{ codeClient: <code />, codeApi: <code /> }}
          values={{ selectedClientName, selectedApiName }}
        />
      ) : (
        <>
          {showClient && (
            <span className={styles.resourceItem}>
              {t('quickstarts.downloadSampleModal.configuredResources.client', 'the application')}{' '}
              <code>{selectedClientName}</code>
            </span>
          )}
          {showClient && showApi && (
            <span> {t('quickstarts.downloadSampleModal.configuredResources.and', 'and')} </span>
          )}
          {showApi && (
            <span className={styles.resourceItem}>
              {t('quickstarts.downloadSampleModal.configuredResources.api', 'the API')} <code>{selectedApiName}</code>
            </span>
          )}
        </>
      )}
    </React.Fragment>
  );
};

ConfiguredResources.propTypes = {
  showClient: PropTypes.bool,
  showApi: PropTypes.bool,
  selectedClientName: PropTypes.string,
  selectedApiName: PropTypes.string,
};

export default ConfiguredResources;
